module.exports = __webpack_public_path__ + "img/Logo_el_Padronet_normal.027d4d94.png";